import { createTheme } from '@mui/material';

const theme = createTheme({
    typography: {
        fontFamily: 'Montserrat',
        fontWeightRegular: 300,
    }
});

export default theme;
